import { getDomainUrl } from 'coreOld/utils';

export const messagesPath = () => '/messages';

export const oldMessagesPath = () => `${getDomainUrl()}/messages/list`;
